import { mergeHostOptions } from 'Domain/schedule-ruleset/helper/mergeHostOptions';

const getAvailableHostResponse = (response, rulesetDetail) => {
  if (!response?.availableHosts) return [];

  const result = mergeHostOptions(response?.availableHosts, rulesetDetail);

  return result?.map((item) => {
    return {
      value: item?.id,
      label: item?.name,
      isPregnancy: item?.isPregnancy,
    };
  });
};

export default getAvailableHostResponse;
